<template>
  <div class="directivesWrap">
    <div class="searchWrap">
      <span class="label"> {{ $tt("指令名称：") }} </span>
      <el-input
        v-model="searchValue"
        :placeholder="$tt('请输入内容')"
        clearable
      ></el-input>
      <span class="label"> {{ $tt("类型：") }} </span>
      <el-select v-model="selectedType" :placeholder="$tt('请选择')" clearable>
        <el-option
          v-for="item in directiveTypes"
          :key="item.id"
          :label="item.type_name"
          :value="item.id"
        >
        </el-option>
      </el-select>
      <el-button type="primary" icon="el-icon-search" @click="search"
        >{{ $tt("搜索") }}</el-button
      >
    </div>
    <div class="operations">
      <el-button type="primary" @click="$router.push('/privateResource/manage/add')"
        >{{ $tt("添加") }}</el-button
      >
      <el-button
        type="danger"
        @click="deleteDirective(selectedDirectives.map((item) => item.id))"
        >{{ $tt("删除") }}</el-button
      >
      <el-button @click="downloadTemplate">{{ $tt("下载模板") }}</el-button>
      <el-button @click="exportExcel">{{ $tt("导出 Excel") }}</el-button>
      <el-button @click="openImportDialog">{{ $tt("导入 Excel") }}</el-button>
    </div>
    <el-dialog
      :title="$tt('导入 Excel')"
      :visible.sync="importDialogVisible"
      width="480px"
      append-to-body
      @closed="resetImportDialog"
    >
      <div class="import-form">
        <div class="import-row">
          <span class="import-label">{{ $tt("指令类型") }}</span>
          <el-select
            v-model="importTypeId"
            :placeholder="$tt('请选择指令类型')"
            filterable
            style="width: 100%"
          >
            <el-option
              v-for="item in directiveTypes"
              :key="item.id"
              :label="item.type_name"
              :value="item.id"
            />
          </el-select>
        </div>
        <p class="import-tip">{{ $tt("导入的所有指令将归入所选类型；相同指令码将自动更新。") }}</p>
        <el-upload
          ref="importUpload"
          action=""
          :auto-upload="false"
          :limit="1"
          accept=".xlsx,.xls"
          :on-change="onImportFileChange"
          :on-remove="onImportFileRemove"
        >
          <el-button size="small" type="primary">{{ $tt("选择文件") }}</el-button>
          <div slot="tip" class="el-upload__tip">{{ $tt("仅支持 .xlsx / .xls") }}</div>
        </el-upload>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="importDialogVisible = false">{{ $tt("取消") }}</el-button>
        <el-button type="primary" :loading="importing" @click="submitImport">{{ $tt("开始导入") }}</el-button>
      </span>
    </el-dialog>
    <div class="directivesList">
      <el-table
        ref="multipleTable"
        :data="directivesListData.result"
        tooltip-effect="dark"
        style="width: 100%"
        border
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column
          :prop="c.key"
          :label="$tt(c.label)"
          :width="$listColWidth(c)"
          :min-width="$listColMinWidth(c)"
          :prop="$listColProp(c)"
          :sortable="$listSortable(c)"
          :class-name="$listColClass(c)"
          :label-class-name="$listColClass(c)"
        :fixed="$listColFixed(c)"
          show-overflow-tooltip
          v-for="c in columns"
          :key="c.key"
        >
          <template slot-scope="scope">
            <span v-if="c.key == 'create_time'">{{
              getTime(scope.row.create_time)
            }}</span>
            <span v-else-if="!!c.format">{{ $tt(c.format(scope.row[c.key])) }}</span>
            <span v-else-if="c.key === 'enter_space_name'">{{ $tt(scope.row[c.key]) }}</span>
            <span v-else>{{ scope.row[c.key] }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="operation"
          :label="$tt('操作')"
          min-width="160"
          width="160"
          class-name="table-ops-cell"
          label-class-name="table-ops-cell"
          key="operation"
          fixed="right"
        >
          <template slot-scope="scope">
            <div class="table-ops">
            <el-button type="text" size="mini" icon="el-icon-edit" @click="toEdit(scope.row.id)"
              >{{ $tt("编辑") }}</el-button
            >
            <el-button
              type="text"
              class="table-op-danger"
              size="mini"
              icon="el-icon-delete"
              @click="deleteDirective([scope.row.id])"
              >{{ $tt("删除") }}</el-button
            >
            </div>
          </template>
        </el-table-column>
      </el-table>

      <Pagination
        v-if="directivesListData.total > 8"
        :handleSizeChange="handleSizeChange"
        :handleCurrentPageChange="handleCurrentPageChange"
        :pageNum="pageNum"
        :total="directivesListData.total"
      />
    </div>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import moment from "moment";
export default {
  components: {
    Pagination,
  },
  data() {
    return {
      columns: [
        {
          key: "instruction_name",
          label: "指令名称",
        },
        {
          key: "instruction_code",
          label: "指令码",
        },
        {
          key: "unicode",
          label: "编码格式",
          format: function(val) {
            return val === '1' ? '字符串' : val === '2' ? '16进制' : '';
          }
        },
        {
          key: "send_type",
          label: "协议类型",
        },

        {
          key: "type_name",
          label: "指令类别",
        },
        {
          key: "create_time",
          label: "创建时间",
        },
        {
          key: "create_by",
          label: "创建者",
        },
        {
          key: "enter_space_name",
          label: "加入回车/空格",
        },
        {
          key: "remark",
          label: "备注",
        },
      ],
      directivesListData: {},
      directiveTypes: [],
      selectedDirectives: [],
      selectedType: "",
      searchValue: "",
      options: [
        {
          label: "1111111111",
          value: 1,
        },
        {
          label: "2222222222",
          value: 2,
        },
        {
          label: "3333333333",
          value: 3,
        },
      ],
      pageNum: 1,
      pageSize: 8,
      importDialogVisible: false,
      importTypeId: "",
      importFile: null,
      importing: false,
    };
  },
  mounted() {
    this.queryDirectivesList({});
    this.getDirectiveTypes();
  },
  methods: {
    search() {
      this.queryDirectivesList({
        instruction_name: this.searchValue,
        type_id: this.selectedType,
      });
    },
    deleteDirective(ids) {
      this.$request.deleteDirective({ ids }).then((res) => {
        if (res.status != "success") {
          this.$message.error(res.msg);
          return;
        }
        this.$message({
          message: "删除成功",
          type: "success",
        });
        this.queryDirectivesList({});
      });
    },
    getDirectiveTypes() {
      this.$request
        .queryDirectiveTypesList({ page_size: 999, page_num: 1 })
        .then((res) => {
          if (res.status != "success") {
            this.$message.error(res.msg);
            return;
          }
          this.directiveTypes = res?.data?.result || [];
        });
    },
    queryDirectivesList({ page_num, page_size }) {
      this.$request
        .queryDirectivesList({
          page_num: page_num || this.pageNum,
          page_size: page_size || this.pageSize,
          instruction_name: this.searchValue,
          type_id: this.selectedType,
        })
        .then((res) => {
          if (res.status != "success") {
            this.$message.error(res.msg);
            return;
          }
          this.directivesListData = res?.data || {};
        });
    },
    getTime(t) {
      return moment(t).format("YYYY-MM-DD HH:mm");
    },
    handleSizeChange(v) {
      this.pageNum = 1;
      this.pageSize = v;
      this.queryDirectivesList({ page_size: v });
    },
    toEdit(id) {
      this.$router.push({
        path: "/privateResource/manage/edit",
        query: {
          id,
        },
      });
    },
    handleCurrentPageChange(v) {
      this.pageNum = v;
      this.queryDirectivesList({ page_num: v });
    },
    handleSelectionChange(val) {
      this.selectedDirectives = val;
    },
    downloadTemplate() {
      this.$request.downloadInstructionTemplate().then((res) => {
        if (res && res.status && res.status !== "success") {
          this.$message.error(res.msg || this.$tt("下载失败"));
        }
      }).catch(() => {
        this.$message.error(this.$tt("下载失败"));
      });
    },
    exportExcel() {
      this.$request.exportInstructions({
        instruction_name: this.searchValue,
        type_id: this.selectedType,
      }).then((res) => {
        if (res && res.status && res.status !== "success") {
          this.$message.error(res.msg || this.$tt("导出失败"));
        }
      }).catch(() => {
        this.$message.error(this.$tt("导出失败"));
      });
    },
    openImportDialog() {
      if (!this.directiveTypes.length) {
        this.$message.warning(this.$tt("请先创建指令类型"));
        return;
      }
      this.importDialogVisible = true;
      if (!this.importTypeId && this.selectedType) {
        this.importTypeId = this.selectedType;
      }
    },
    resetImportDialog() {
      this.importTypeId = this.selectedType || "";
      this.importFile = null;
      this.importing = false;
      if (this.$refs.importUpload) {
        this.$refs.importUpload.clearFiles();
      }
    },
    onImportFileChange(file) {
      this.importFile = file && file.raw ? file.raw : null;
    },
    onImportFileRemove() {
      this.importFile = null;
    },
    submitImport() {
      if (!this.importTypeId) {
        this.$message.warning(this.$tt("请选择指令类型"));
        return;
      }
      if (!this.importFile) {
        this.$message.warning(this.$tt("请选择 Excel 文件"));
        return;
      }
      this.importing = true;
      this.$request.importInstructions(this.importFile, this.importTypeId).then((res) => {
        this.importing = false;
        if (res.status !== "success") {
          this.$message.error(res.msg || this.$tt("导入失败"));
          return;
        }
        const data = res.data || {};
        const msg = `导入完成：新增 ${data.inserted || 0}，更新 ${data.updated || 0}，跳过 ${data.skipped || 0}`;
        this.$message.success(msg);
        if (data.errors && data.errors.length) {
          this.$alert(data.errors.slice(0, 20).join("\n"), this.$tt("部分行已跳过"), {
            confirmButtonText: this.$tt("知道了"),
          });
        }
        this.importDialogVisible = false;
        this.queryDirectivesList({});
      }).catch(() => {
        this.importing = false;
        this.$message.error(this.$tt("导入失败"));
      });
    },
  },
};
</script>

<style lang='scss' scoped>
.directivesWrap {
  background-color: #fff;
  .searchWrap {
    display: flex;
    border-bottom: 1px solid #e6e6e6;
    padding: 16px 0;
    align-items: center;
    .label {
      margin-left: 16px;
    }
    .el-input {
      width: 200px !important;
    }
    .el-button {
      margin-left: 16px;
    }
  }
  .operations {
    margin: 24px 24px 0;
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }
  .import-form {
    .import-row {
      display: flex;
      align-items: center;
      gap: 12px;
      margin-bottom: 12px;
    }
    .import-label {
      flex: 0 0 auto;
      white-space: nowrap;
      color: #606266;
    }
    .import-tip {
      margin: 0 0 12px;
      font-size: 12px;
      color: #909399;
      line-height: 1.6;
    }
  }
  .directivesList {
    padding: 10px 24px 24px;
  }
}
</style>